import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './menu.component';
import { WmTransitionModule } from '../transition/index';
import { WmIconModule } from '../icon/index';
import { RouterModule } from '@angular/router';
import { MenuItemComponent } from './menu-item/menu-item.component';

@NgModule({
	declarations: [MenuComponent, MenuItemComponent],
	imports: [CommonModule, WmTransitionModule, WmIconModule, RouterModule],
	exports: [MenuComponent, MenuItemComponent]
})
export class WmMenuModule {}
